import { actions } from "./sinistro.actions";
import { types as routes } from "./rotas.actions";

const initialState = {
  sinistros: {
    loading: false,
    page: 1,
    count: 0,
    cliente: "",
    seguradora: "",
    competencia: "",
    data: [],
    filtros: "",
  },
  sinistro: {
    loading: false,
    data: [],
  },
  valores: {
    loading: false,
    data: [],
  },
  sinistroOutros: {
    loading: false,
    data: [],
  },
  sinistroBeneficiarios: {
    loading: false,
    data: [],
  },
  situacao: {
    loading: false,
    data: "N",
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.obterSinistros.REQUEST:
    case actions.obterSinistros.SUCCESS:
    case actions.obterSinistros.FAILURE:
      return {
        ...state,
        sinistros: {
          ...state.sinistros,
          loading: action.type === actions.obterSinistros.REQUEST,
          data:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.resultado
              : [],
          cliente:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.filter?.cliente ?? ""
              : [],
          seguradora:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.filter?.seguradora ?? ""
              : [],
          competencia:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.filter?.competencia ?? ""
              : [],
          page:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.paginaAtual
              : [],
          count:
            action.type === actions.obterSinistros.SUCCESS
              ? action.payload.response.data.total
              : [],
          filtros:
            action.type === actions.obterSinistros.REQUEST
              ? action.payload.filtro
              : state.sinistros.filtros,
        },
      };
    case actions.editarSinistro.REQUEST:
    case actions.editarSinistro.SUCCESS:
    case actions.editarSinistro.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.editarSinistro.REQUEST,
          data:
            action.type === actions.editarSinistro.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };

    case routes.EDIT_USUARIOS:
      return {
        ...state,
        id: action.payload.id,
      };

    case actions.mostrarSinistro.REQUEST:
    case actions.mostrarSinistro.SUCCESS:
    case actions.mostrarSinistro.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          breakeven:
            action.type === actions.mostrarSinistro.SUCCESS
              ? action.payload.response.data.breakeven
              : 0,
          loading: action.type === actions.mostrarSinistro.REQUEST,
          data:
            action.type === actions.mostrarSinistro.SUCCESS
              ? action.payload.response.data
              : [],
        },
        situacao: {
          ...state.situacao,
          loading: action.type === actions.mostrarSinistro.REQUEST,
          data:
            action.type === actions.mostrarSinistro.SUCCESS
              ? action.payload.response.data.situacao
              : [],
        },
      };
    case actions.uploadSinistroDocumentos.REQUEST:
    case actions.uploadSinistroDocumentos.SUCCESS:
    case actions.uploadSinistroDocumentos.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.uploadSinistroDocumentos.REQUEST,
          data:
            action.type === actions.uploadSinistroDocumentos.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.criarSinistro.REQUEST:
    case actions.criarSinistro.SUCCESS:
    case actions.criarSinistro.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.criarSinistro.REQUEST,
          data:
            action.type === actions.criarSinistro.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.deletarSinistro.REQUEST:
    case actions.deletarSinistro.SUCCESS:
    case actions.deletarSinistro.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.deletarSinistro.REQUEST,
        },
      };
    case actions.obterValores.REQUEST:
    case actions.obterValores.SUCCESS:
    case actions.obterValores.FAILURE:
      return {
        ...state,
        valores: {
          ...state.valores,
          loading: action.type === actions.obterValores.REQUEST,
          data:
            action.type === actions.obterValores.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterSinistroOutros.REQUEST:
    case actions.obterSinistroOutros.SUCCESS:
    case actions.obterSinistroOutros.FAILURE:
      return {
        ...state,
        sinistroOutros: {
          ...state.sinistroOutros,
          loading: action.type === actions.obterSinistroOutros.REQUEST,
          data:
            action.type === actions.obterSinistroOutros.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterSinistroBeneficiarios.REQUEST:
    case actions.obterSinistroBeneficiarios.SUCCESS:
    case actions.obterSinistroBeneficiarios.FAILURE:
      return {
        ...state,
        sinistroBeneficiarios: {
          ...state.sinistroBeneficiarios,
          loading: action.type === actions.obterSinistroBeneficiarios.REQUEST,
          data:
            action.type === actions.obterSinistroBeneficiarios.SUCCESS
              ? action.payload.response.data.data
              : [],
          planos:
            action.type === actions.obterSinistroBeneficiarios.SUCCESS
              ? action.payload.response.data.planos
              : [],
        },
      };
    case actions.atualizarSituacao.REQUEST:
    case actions.atualizarSituacao.SUCCESS:
    case actions.atualizarSituacao.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.atualizarSituacao.REQUEST,
        },
        situacao: {
          ...state.situacao,
          loading: action.type === actions.atualizarSituacao.REQUEST,
          data:
            action.type === actions.atualizarSituacao.SUCCESS
              ? action.payload.response.data.situacao
              : [],
        },
      };
    case actions.aprovarSituacao.REQUEST:
    case actions.aprovarSituacao.SUCCESS:
    case actions.aprovarSituacao.FAILURE:
      return {
        ...state,
        sinistro: {
          ...state.sinistro,
          loading: action.type === actions.aprovarSituacao.REQUEST,
        },
        situacao: {
          ...state.situacao,
          loading: action.type === actions.aprovarSituacao.REQUEST,
          data:
            action.type === actions.aprovarSituacao.SUCCESS
              ? action.payload.response.data.situacao
              : [],
        },
      };

    default:
      return state;
  }
};

export default reducer;
